/* eslint-disable */
import { useState, useEffect, useMemo } from "react";
import { OLAPTransformerResult, useParameter, useDictionary, Column } from "../../../shared";
import Highcharts, { SeriesOptionsType } from "highcharts";
import { useChartOptions } from "../../../../charts/useChartOptions";
import { legendPipe, chartPipe, tooltipPipe, addXAxisPipe, addYAxisPipe } from "../../../../charts/pipes";
import { dictionaryService } from "../../../dataFlow";
import { arrayByLength, uniq } from "../../../../../shared";
import { last } from "lodash";
import { TableProps } from "../../../components/Table";
import { ColDef } from "ag-grid-community";
import { SLIDE_NUMBER } from "../constants";

const COLUMNS_AXIS = "attributes.default";
const ROWS_AXIS = "calendar.default";
const YEAR_FREQUENCY = 1;
const DISPLAY_ATTR = 7;

export function useAgGridTransformerStockUseRatio(olapData: OLAPTransformerResult | null): TableProps | undefined {
  const [state, setState] = useState<TableProps | undefined>();
  const [calendarParameter] = useParameter<number[]>('@calendar');
  const calendarParameterYears = calendarParameter?.filter(calendarId => {
    const frequency = Number(String(calendarId)[0]);
    return frequency === YEAR_FREQUENCY;
  }).sort(Number).slice(-5);

  useEffect(() => {
    if (olapData) {
      const dataRow = olapData?.rows.find(row => row.selection[COLUMNS_AXIS] === DISPLAY_ATTR);
      const rows = calendarParameterYears?.map((calendarId) => {
        const yearPoint = dataRow?.points.find(point => point.column.selection[ROWS_AXIS] === calendarId);
        const yearName = yearPoint?.attributes && yearPoint?.attributes[`${ROWS_AXIS}.name`];
        const year = Number(yearName);
        const shortNextYear = String(year + 1).slice(2, 4);
        const rowName = [yearName, shortNextYear].join('/');

        const recordsRow = {
          name: rowName,
          id: calendarId,
          value: Intl.NumberFormat('es-US', { style: 'percent' }).format(yearPoint?.value || 0),
        };
        return recordsRow;
      }) || [];

      const periodCol: ColDef = { headerName: "", field: "name", resizable: true };
      const valueCol: ColDef = { headerName: "", field: "value", resizable: true };
      const result: TableProps = {
        columns: [periodCol, valueCol],
        rows,
      }

      setState(result);
    } else {
      setState(undefined);
    }
  }, [olapData, calendarParameter]);

  return state;
}
